import TEALIUM from "../../../enums/tealium-enums";
import { track } from "../../../util/tealium";

export const ilbPageLoadTrack = (period: string) => {
  track(TEALIUM.U_TAG_METHOD.VIEW, "", "", TEALIUM.CATEGORY.ILB, `ILB:${period}`, "");
};

export const viewMBIStatementTrack = () => {
  track(TEALIUM.U_TAG_METHOD.LINK, TEALIUM.EVENT_NAME.CLICK_ACTION, "", TEALIUM.CATEGORY.ILB, "", "back_to_MBI");
};

export const ilbNoStatementPageTrack = () => {
  track(TEALIUM.U_TAG_METHOD.VIEW, "", "", TEALIUM.CATEGORY.ILB, `ILB_no_statement`, "");
};
